import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { fetchPage } from '../lib/cms';
import ContactForm from '../components/ContactForm';
import { useScrollReveal } from '../hooks/useScrollReveal';

export default function Contact() {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadData() {
      const data = await fetchPage('page-kontakt');
      setPageData(data);
      setLoading(false);
    }
    loadData();
  }, []);

  const metaTitle = pageData?.meta_title || 'Kontakt - JE Entreprenør';
  const metaDesc = pageData?.meta_description || 'Kontakt JE Entreprenør i Skårup Fyn for et uforpligtende tilbud på entreprenørarbejde, asfalt eller rørlægning på Sydfyn.';
  const heroTitle = pageData?.hero_title || 'Kontakt Os';
  const heroSubtitle = pageData?.hero_subtitle || 'Lad os tage en uforpligtende snak om dit næste projekt på Sydfyn. Vi sidder klar ved telefonen.';

  return (
    <>
      <Helmet>
        <title>{metaTitle}</title>
        <meta name="description" content={metaDesc} />
        <meta property="og:title" content={metaTitle} />
        <meta property="og:description" content={metaDesc} />
        <meta property="og:image" content="https://assets.auxodev.dk/assets/ca189e60-8ca7-4520-a859-93fb9daa9500/hero-entreprenoer.jpg" />
      </Helmet>

      {/* Contact Grid */}
      <section 
        className="py-16 bg-white"
      >
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 gap-12 lg:grid-cols-2">
            
            {/* Contact Info Column */}
            <div>
              <h2 className="font-display text-2xl font-extrabold uppercase tracking-tight text-asphalt-900">
                Direkte Kontaktoplysninger
              </h2>
              <div 
                className="mt-4 text-base text-asphalt-600 space-y-4 leading-relaxed"
                dangerouslySetInnerHTML={{ __html: pageData?.content || '' }}
              />

              <div className="mt-8 divide-y divide-black">
                <div className="flex items-start gap-4 py-6 first:pt-0 last:pb-0">
                  <div className="text-safety-orange shrink-0">
                    <i className="fa-solid fa-phone text-xl"></i>
                  </div>
                  <div>
                    <a href="tel:+4551172145" className="block text-lg font-bold text-asphalt-900 hover:text-safety-orange transition-colors duration-150">
                      51 17 21 45
                    </a>
                    <p className="mt-1 text-xs text-asphalt-500">Vi svarer alle hverdage 07:00 - 17:00</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 py-6 first:pt-0 last:pb-0">
                  <div className="text-safety-orange shrink-0">
                    <i className="fa-solid fa-envelope text-xl"></i>
                  </div>
                  <div>
                    <a href="mailto:je.entreprenor@gmail.com" className="block text-lg font-bold text-asphalt-900 hover:text-safety-orange transition-colors duration-150">
                      je.entreprenor@gmail.com
                    </a>
                    <p className="mt-1 text-xs text-asphalt-500">Vi besvarer e-mails inden for 24 timer</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 py-6 first:pt-0 last:pb-0">
                  <div className="text-safety-orange shrink-0">
                    <i className="fa-solid fa-location-dot text-xl"></i>
                  </div>
                  <div>
                    <p className="text-lg font-bold text-asphalt-900">
                      Nyborgvej 506A, 5881 Skårup Fyn
                    </p>
                    <p className="mt-1 text-xs text-asphalt-500">Vores hovedkontor og maskindepot</p>
                  </div>
                </div>

                <div className="flex items-start gap-4 py-6 first:pt-0 last:pb-0">
                  <div className="text-safety-orange shrink-0">
                    <i className="fa-solid fa-id-card text-xl"></i>
                  </div>
                  <div>
                    <p className="text-base font-bold text-asphalt-900">
                      JE Entreprenør
                    </p>
                    <p className="mt-1 text-xs text-asphalt-500">CVR-nummer: 42629421</p>
                  </div>
                </div>
              </div>

              {/* Local Area Map Placeholder */}
              <div className="mt-10 rounded-2xl border border-asphalt-200 bg-asphalt-50 p-6 text-center">
                <i className="fa-solid fa-map-location-dot text-4xl text-safety-orange mb-4"></i>
                <h3 className="font-display text-base font-bold text-asphalt-900">Vi dækker hele Sydfyn</h3>
                <p className="mt-2 text-xs text-asphalt-600 max-w-md mx-auto leading-relaxed">
                  Vi udfører opgaver i Svendborg, Skårup, Nyborg, Faaborg, Ringe, Tåsinge, Langeland og alle de mellemliggende områder.
                </p>
              </div>
            </div>

            {/* Form Column */}
            <div>
              <ContactForm />
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
